// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"821":"2860ca51a72e74b8","3404":"6ca87206e42076a5"}[chunkId] + ".js";
};